import { Check } from "@phosphor-icons/react";
import clsx from "clsx";
import React from "react";

type FormCheckboxProps = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "type" | "id"
> & {
    id: string;
    label: string;
};

const FormCheckbox = ({
    label,
    checked,
    id,
    className,
    ...props
}: FormCheckboxProps) => {
    return (
        <label htmlFor={id} className="flex items-center gap-3">
            <div className="relative">
                <input
                    id={id}
                    type="checkbox"
                    className={clsx("absolute inset-0 opacity-0", className)}
                    {...props}
                />
                <div
                    className={clsx(
                        "w-5 h-5 rounded-[0.188rem] border border-surface-dark-1 text-surface-dark-1 flex items-center justify-center",
                        checked && "bg-soft-green-80"
                    )}
                >
                    {checked && <Check weight="bold" size={14} />}
                </div>
            </div>
            <span className=" select-none">{label}</span>
        </label>
    );
};

export default FormCheckbox;
